<template>
    <div class="TheModeB">
        <div class="Title">
            <div>
                <p>主营产品</p>
            </div>
            <!-- <span>MAIN PRODBCTSD</span> -->
        </div>
        <el-row type="flex" class="row-bg model" justify="center">
            <el-col :span="20" class="hidd">
                <el-carousel
                    :loop="false"
                    :height="innerheight + 'px'"
                    arrow="never"
                    indicator-position="outside"
                >
                    <el-carousel-item>
                        <el-col
                            :span="8"
                            class="glide"
                            v-for="(item, index) in toplist"
                            :key="index"
                        >
                            <img :src="item.image" />
                            <el-row type="flex">
                                <div
                                    @click="JumpSmallPieces(item)"
                                    class="mask"
                                >
                                    <i class="el-icon-back icon"></i>
                                </div>
                            </el-row>
                            <el-row type="flex" class="row-bg" justify="center">
                                <el-col class="details" :span="24">
                                    <div class="compatible">
                                        <p>
                                            <i :class="item.icon"></i
                                            >{{ item.toMeauName }}
                                        </p>
                                        <p class="small">
                                            {{ item.description }}
                                        </p>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-carousel-item>
                    <el-carousel-item>
                        <el-col
                            :span="8"
                            class="glide"
                            v-for="(item, index) in bottomlist"
                            :key="index"
                        >
                            <img :src="item.image" />
                            <el-row type="flex">
                                <div
                                    @click="JumpSmallPieces(item)"
                                    class="mask"
                                >
                                    <i class="el-icon-back icon"></i>
                                </div>
                            </el-row>
                            <el-row type="flex" class="row-bg" justify="center">
                                <el-col class="details" :span="24">
                                    <div class="compatible">
                                        <p>
                                            <i :class="item.icon"></i
                                            >{{ item.toMeauName }}
                                        </p>
                                        <p class="small">
                                            {{ item.description }}
                                        </p>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-carousel-item>
                </el-carousel>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { queryhomecategoryid } from "@/api/productInfo";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            mainlist: [],
            topicon: [
                {
                    icon: "iconfont icon-xiaojianzhengli"
                },
                {
                    icon: "iconfont icon-shangmen"
                },
                {
                    icon: "iconfont icon-jikuaiyun"
                }
            ],
            bottomicon: [
                {
                    icon: "iconfont icon-jikuaiyun"
                },
                {
                    icon: "iconfont icon-jizhonghuo"
                },
                {
                    icon: "iconfont icon-zhengcheguanli"
                }
            ],
            toplist: [],
            bottomlist: [],
            innerheight: 320,
            bannerH: 0,
            screenWidth: 1920,
            id: {
                data: {
                    categoryId: "C2488E92-CBF9-C76B-52E8-8D02233B6C8D"
                }
            }
        };
    },
    computed: {
        ...mapGetters(["parentList"])
    },
    mounted() {
        this.$store.dispatch("ParentList", "");
        this.setSize1();
        const that = this;
        //监听浏览器窗口大小改变
        window.addEventListener(
            "resize",
            function() {
                var width =
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth;
                that.screenWidth = width;
                that.setSize();
            },
            false
        );
    },
    created() {
        this.search();
    },
    methods: {
        search() {
            queryhomecategoryid()
                .then(res => {
                    if (res.status === 2000) {
                        this.mainlist = res.data;
                        this.toplist = this.mainlist.slice(0, 3);
                        for (
                            let index = 0;
                            index < this.toplist.length;
                            index++
                        ) {
                            this.toplist[index].icon = this.topicon[index].icon;
                        }
                        this.bottomlist = this.mainlist.slice(-3);
                        for (
                            let index = 0;
                            index < this.bottomlist.length;
                            index++
                        ) {
                            this.bottomlist[index].icon = this.bottomicon[
                                index
                            ].icon;
                        }
                    }
                })
                .catch(err => {});
        },
        setSize1: function() {
            var width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            this.screenWidth = width;
            //图片                高 / 宽  700 / 1920
            if (this.screenWidth > 1200) {
                this.innerheight = 420 / 1800 * this.screenWidth;
                this.bannerH = this.innerheight;
            } else {
                this.innerheigh = 420;
            }
        },
        setSize: function() {
            if (this.screenWidth > 1200) {
                this.innerheight = 460 / 1800 * this.screenWidth;
                this.bannerH = this.innerheight;
            } else {
                this.innerheigh = 420;
            }
        },
        JumpSmallPieces(name) {
            this.$router.push({
                path: name.demoFlag,
                query: {
                    id: name.id
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.TheModeB {
    .Title {
        text-align: center;
        margin-top: 10px;
        p {
            display: inline-block;
            margin: 0;
            font-size: 24px;
        }
        span {
            display: inline-block;
            margin-top: 8px;
            font-size: 11px;
            color: #666;
        }
    }
    .model {
        margin-top: 60px;
        // overflow: hidden;
        .el-carousel {
            overflow: hidden;
        }
        .hidd {
            // height: 263px;
            position: relative;
            overflow: hidden;
            img {
                width: 100%;
                // max-height: 285px;
            }
            .glide {
                padding: 0 10px;
                position: relative;
                .mask {
                    width: 100%;
                    height: 473px;
                    position: absolute;
                    bottom: 2px;
                    background-color: rgba(#000, 0.5);
                    display: none;
                    .icon {
                        font-size: 43px;
                        transform: rotate(180deg);
                        cursor: pointer;
                        position: relative;
                        top: 70%;
                        transform: translateY(30%), rotate(180deg);
                        left: 45%;
                        color: #fff;
                    }
                }
                .details {
                    // z-index: 5;
                    height: 112px;
                    margin-top: -3px;
                    background-color: #f5f6f7;
                    // transition: all 1s linear;
                    .compatible {
                        height: 112px;
                        // border-top: 5px solid #eab305;
                        p {
                            padding: 0 20px;
                            font-size: 20px;
                            line-height: 36px;
                        }
                        p:nth-child(1) {
                            margin-top: 10px;
                        }
                        .small {
                            font-size: 13px;
                            color: #666;
                            line-height: 19px;
                            // display: -webkit-box;
                            // -webkit-box-orient: vertical;
                            // -webkit-line-clamp: 2;
                            // overflow: hidden;
                        }
                        .iconfont {
                            font-size: 24px;
                            margin-right: 10px;
                        }
                    }
                }
            }
            .glide:hover {
                .mask {
                    display: block;
                }
                .details {
                    background-color: #fabe00;
                    p {
                        color: #fff;
                    }
                    .small {
                        color: #fff;
                    }
                }
            }
        }
        // /deep/ .el-carousel__indicators--outside button {
        //     width: 45px;
        //     height: 6px;
        //     border-radius: 6px;
        //     background-color: #fabe00;
        // }
        /deep/ .el-carousel__indicator.is-active button {
            width: 45px;
            height: 6px;
            border-radius: 6px;
            background-color: #fabe00;
        }
        /deep/ .el-carousel__indicators--outside button {
            width: 45px;
            height: 6px;
            border-radius: 6px;
            background-color: #d3d3d3;
            opacity: 1;
        }
        /deep/
            .el-carousel__indicators--outside
            .el-carousel__indicator:hover
            button {
            opacity: 1;
        }
    }
}
</style>
